'use client';

import { useEffect, useState } from 'react';
import { useRouter } from 'next/navigation';
import { auth } from '@/firebaseConfig';
import { onAuthStateChanged } from 'firebase/auth';
import { DEV_UID } from '@/constants';
import CardDesignStudio from '@/components/CardDesignStudio';

export default function StudioPage() {
  const router = useRouter();
  const [loading, setLoading] = useState(true);
  const [authorized, setAuthorized] = useState(false);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (!user || user.uid !== DEV_UID) {
        // Not authorized - redirect to home
        router.push('/');
      } else {
        setAuthorized(true);
      }
      setLoading(false);
    });

    return () => unsubscribe();
  }, [router]);

  if (loading) {
    return (
      <div className="lobby studio-lobby" style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}>
        <div>Loading...</div>
      </div>
    );
  }

  if (!authorized) {
    return null; // Redirecting...
  }

  return (
    <div className="lobby studio-lobby">
      <CardDesignStudio />
    </div>
  );
}
